import {
  categories_tab,
  menus_tab,
  modifier_groups_tab,
  modifiers_tab,
  products_tab,
} from '../../../../../../views/menu/smart-pricing';
import { SMART_PRICING_RESOURCE_TYPE } from '../../../../../../services/exports/Constants';

export default {
  title: 'Slimme prijsstelling',
  master_title: 'Merkmodus - Slimme prijsstelling',
  sections: {
    how_it_works: {
      title: 'Hoe het werkt',
      description:
        "Slimme prijsstelling is een functie waarmee u uw prijzen kunt sturen op basis van de bestelwijze van de klant. Dit omvat meerdere scenario's, zoals prijsverlaging voor afhalen, prijsverhoging voor bezorging, korting op een seizoensmenu, enz. U kunt regels aanmaken op meerdere niveaus (Globaal, Menu, Categorie, Product, Modifiergroep, Modifier). Niveaus werken als een boom: een hoger niveau beïnvloedt de lagere niveaus. Tegelijkertijd heeft een lager niveau prioriteit boven een hoger niveau (bijv. een afhaalkorting van 5% op een specifieke categorie overschrijft de globale afhaalkorting van 15% voor die producten).",
    },
  },
  tabs: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Globale regels',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Globale regels',
    [menus_tab]: 'Menuregels',
    [categories_tab]: 'Categorieregels',
    [products_tab]: 'Productregels',
    [modifier_groups_tab]: 'Modifiergroepregels',
    [modifiers_tab]: 'Modifierregels',
  },
  fields: {
    name: 'Naam',
    order_methods: 'Bestelmethoden',
    modifier: 'Modifier',
    image: 'Afbeelding',
    actions: 'Acties',
  },
  labels: {
    absolute: 'Absoluut',
  },
  buttons: {
    add_rule: 'Regel toevoegen',
    edit: 'Bewerken',
    delete: 'Verwijderen ({{count}})',
    images: 'Afbeelding beheren',
  },
  popups: {
    delete_rule: {
      title: 'Zeker verwijderen?',
    },
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
    failed_to_delete: 'Regels verwijderen mislukt',
    deleted_successfully: 'Regels succesvol verwijderd',
  },
};
